import { Injectable } from '@angular/core';
import { AppService, BASE_URL_SSO } from '../app.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PermissionGroupService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  all(accessToken: string = null): Observable<Response> {
    this.endpoint = `${BASE_URL_SSO}/permissions/groups`;
    return this.get(this.endpoint, accessToken);
  }

  userPermission(accessToken: string = null): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/users/me/permissions`;
    return this.get(this.endpoint, accessToken);
  }

  userPermissionAdministration(administratinID, accessToken: string = null, ): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/users/me/permissions/administration/${administratinID}`;
    return this.get(this.endpoint, accessToken);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/permissionGroup.service.ts